import { getAuthHeaders } from "./authService.js";

const domain = process.env.REACT_APP_DOMAIN;

// ─── FIELDS ────────────────────────────────────────────

export async function fetchFields() {
  const response = await fetch(`${domain}/api/v1/dynamicField/`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data?.message || "Failed to fetch fields");
  return data;
}

export async function fetchFieldById(fieldId) {
  const response = await fetch(
    `${domain}/api/v1/dynamicField/fields/${fieldId}`,
    {
      method: "GET",
      headers: getAuthHeaders(),
    }
  );
  const data = await response.json();
  if (!response.ok) throw new Error(data?.message || "Failed to fetch field");
  return data;
}

export async function createField({ field_label, field_type = "dropdown" }) {
  const response = await fetch(`${domain}/api/v1/dynamicField/field`, {
    method: "POST",
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ field_label, field_type }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data?.message || "Failed to create field");
  return data;
}

export async function updateField(fieldId, { field_label, field_type, sort_order }) {
  const response = await fetch(`${domain}/api/v1/dynamicField/field/${fieldId}`, {
    method: "PUT",
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ field_label, field_type, sort_order }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data?.message || "Failed to update field");
  return data;
}

export async function deleteField(fieldId) {
  const response = await fetch(`${domain}/api/v1/dynamicField/field/${fieldId}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data?.message || "Failed to delete field");
  return data;
}

// ─── OPTIONS ───────────────────────────────────────────

export async function fetchOptions(fieldId) {
  const response = await fetch(
    `${domain}/api/v1/dynamicField/option/${fieldId}`,
    {
      method: "GET",
      headers: getAuthHeaders(),
    }
  );
  const data = await response.json();
  if (!response.ok) throw new Error(data?.message || "Failed to fetch options");
  return data;
}

export async function createOption(fieldId, { option_label }) {
  const response = await fetch(
    `${domain}/api/v1/dynamicField/${fieldId}/options`,
    {
      method: "POST",
      headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
      body: JSON.stringify({ option_label }),
    }
  );
  const data = await response.json();
  if (!response.ok) throw new Error(data?.message || "Failed to create option");
  return data;
}

export async function updateOption(optionId, { option_label, sort_order }) {
  const response = await fetch(
    `${domain}/api/v1/dynamicField/option/${optionId}`,
    {
      method: "PUT",
      headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
      body: JSON.stringify({ option_label, sort_order }),
    }
  );
  const data = await response.json();
  if (!response.ok) throw new Error(data?.message || "Failed to update option");
  return data;
}

export async function deleteOption(optionId) {
  const response = await fetch(
    `${domain}/api/v1/dynamicField/options/${optionId}`,
    {
      method: "DELETE",
      headers: getAuthHeaders(),
    }
  );
  const data = await response.json();
  if (!response.ok) throw new Error(data?.message || "Failed to delete option");
  return data;
}
